import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from "./components/App.js";
import {UserUtils} from "./utils/UserUtils.js";

const root = ReactDOM.createRoot(document.getElementById('root'));

UserUtils.init().then(() => root.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>
));

